import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private subs = new SubSink();

  url$ = new BehaviorSubject<string>('');
  label$ = new BehaviorSubject<string>('');
  prefixUrl$ = new BehaviorSubject<string>('');
  prefixLabel$ = new BehaviorSubject<string>('');

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    this.subscribeToBreadcrumbs();
  }

  subscribeToBreadcrumbs() {
    this.subs.sink = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child) {
            if (child.firstChild) {
              child = child.firstChild;
            } else if (
              child.snapshot.data &&
              child.snapshot.data["title"] &&
              child.snapshot.data["breadcrumb"] &&
              child.snapshot.data["breadcrumb"]["label"] &&
              child.snapshot.data["breadcrumb"]["url"]
            ) {
              return child.snapshot.data;
            } else {
              return null;
            }
          }
        })
      )
      .subscribe((data: any) => {
        if (data) {
          data.title && this.titleService.setTitle(data.title);
          data.breadcrumb.url && this.setBreadcrumbUrl(data.breadcrumb.url);
          data.breadcrumb.label && this.setBreadcrumbLabel(data.breadcrumb.label);
          this.setBreadcrumbPrefixes();
        }
      });
  }

  setBreadcrumbPrefixes() {
    const navFrom = sessionStorage.getItem('NAV_FROM');
    const url = this.router.url.split('/')
    let link = '/'
    let label = ''
    switch (url[1]) {
      case 'home':
        link += 'user/user-management'
        label = 'Utilization Review'
        break;
      case 'admin':
        link += 'admin'
        label = 'Administration'
        break;
      case 'client':
        link += 'admin'
        label = 'Administration'
        break;
      case 'claim':
        link += 'home'
        label = 'KlearClaims'
        break;
      case 'user':
      case 'um':
        link += 'user/user-management'
        label = 'Home'
        break;
      case 'ur':
        link += 'ur/util-search'
        label = 'Utilization Review'
      case 'request':
        link += 'request/req-summary'
        label = 'Utilization Review'
        break;
      default:
        link += 'user/user-management'
        label = navFrom;
        break;
    }
    this.prefixUrl$.next(link)
    this.prefixLabel$.next(label)
  }

  setBreadcrumbUrl(url: string) {
    this.url$.next(url);
  }

  setBreadcrumbLabel(label: string) {
    this.label$.next(label);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
